import React from "react";
import { useNavigate } from "react-router-dom";
import FacebookConnectPage from "./FacebookConnectPage";

const BroadcastConnect: React.FC = () => {
  const navigate = useNavigate();
  return (
    <FacebookConnectPage
      title="Connect Caucus to your Facebook Page"
      configId={process.env.REACT_APP_CONFIG_ID!}
      onCode={(code) =>
        navigate("/facebookManage", { state: { authCode: code, authType: "broadcast" } })
      }
    />
  );
};

export default BroadcastConnect;
